import React from "react";
import _ from "lodash";
import {
  compose,
  withHandlers,
  setDisplayName,
  lifecycle,
  branch,
  renderNothing,
  renderComponent
} from "recompose";
import { connect } from "react-redux";
import { actions, selectors } from "../modules/contacts";
import ContactList from "./ContactList";
import FontAwesomeIcon from "@fortawesome/react-fontawesome";
import { faEdit } from "@fortawesome/fontawesome-free-solid";
import Button from "./CustomButton";
import AddContactForm from "./AddContactForm";
import UpdateContactForm from "./UpdateContactForm";

const mapStateToProps = state => ({
  submittingContact: selectors.isLoadingSubmitContact(state),
  currentCustomer: state.customers.currentCustomer,
  currentContact: selectors.getCurrentContact(state),
  contacts: selectors.getContacts(state),
  role: state.settings.role
});

const mapDispatchToProps = {
  setCurrentContact: actions.setCurrentContact,
  resetState: actions.resetState
};

const withContactState = connect(
  mapStateToProps,
  mapDispatchToProps
);

const ContactsEnhacer = compose(
  setDisplayName("Contacts"),
  withContactState,
  branch(({ contacts }) => _.isEmpty(contacts), renderNothing)
);

const Contacts = compose(ContactsEnhacer)(ContactList);

const withLifeCycle = lifecycle({
  componentWillUnmount() {
    this.props.resetState();
  }
});

const CustomerNeededMessage = () => (
  <h4 className="text-muted">Please, select a customer to manage contacts.</h4>
);

const enhanced = compose(
  setDisplayName("ContactSection"),
  withContactState,
  branch(
    ({ currentCustomer }) => !currentCustomer,
    renderComponent(CustomerNeededMessage)
  ),
  withLifeCycle,
  withHandlers({
    onClickUpdateContact: ({ setCurrentContact }) => contact => () => {
      setCurrentContact(contact);
    }
  })
);

const ContactSection = enhanced(
  ({
    title,
    submittingContact,
    onClickUpdateContact,
    currentContact,
    role
  }) => {
    return (
      <div>
        {title && <h4>{title}</h4>}
        {!currentContact && role !== "contact" && <AddContactForm />}
        {currentContact && <UpdateContactForm />}
        <Contacts>
          {({ contact }) =>
            role !== "contact" ? (
              <Button
                color="info"
                simple
                disabled={submittingContact}
                onClick={onClickUpdateContact(contact)}
              >
                <FontAwesomeIcon icon={faEdit} />
              </Button>
            ) : (
              <></>
            )
          }
        </Contacts>
      </div>
    );
  }
);

export default ContactSection;
